<template>
  <div>
    <base-info ref="baseInfo" v-model="form" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file :contract-num="form.contractNum" :is-init="false" />
      </div>
    </div>
    <product-list
      ref="product"
      :rebate-amount="form.rebateAmount"
      :communication-order-discount="form.communicationOrderDiscount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-type="form.contractType"
      :form="form"
      @chooseAddress="
        val => {
          form.receiptAddressId = val.id;
        }
      "
    />

    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit(0)">
          发布合同
        </el-button>
        <el-button type="default" :loading="loading" @click="submit(1)">
          保存草稿
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import productList from '../internationalProductList';
import contractFile from '../../../Chief/contract/common/contractFile';

import { saveOrderContractInfo, createContractNum, getCountryOrSpecificationPowerCord } from '@/API';
import { getCalculateInterSettlementAmountV2 } from '@/API/international';
import { buildIntlOrderPublishComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      newContract: 'newContract',
      form: {
        contractNum: '',
        customerContractNum: '',
        isOrderAdminCreate: true,
        supplyUnitId: 2,
        supplyUnit: '锐捷网络股份有限公司',
        supplyAddress: '福州市金山大道618号桔园洲标准厂房22',
        supplyPhone: '',
        orderUnitCode: '',
        orderUnit: '',
        orderUnitPhone: '',
        paymentBankId: '',
        saleTypeCode: '',
        saleTypeName: '',
        finalCustomer: '',
        finalCustomerEmail: '',
        customerContractType: '',
        salesType: 1,
        shipType: 1,
        rebate: 1,
        isTestProject: 0,
        contractTypeCode: '',
        applicationScenariosCode: '',
        applicationSceneCode: '',
        contractType: '国际业务下单',
        shippingType: 0,
        // paymentMethodCode: '立即付款',
        paymentMethodName: '立即',
        currencyId: 'USD',
        isRebate: false,
        soldCountry: '', // 销往国家
        countryCode: '',
        powerCordSpecification: '', // 2pin电线规格
        threePlugPowerCord: '' // 3pin电线规格
      },
      loading: false
    };
  },
  components: {
    baseInfo,
    contractFile,
    productList
  },
  computed: {},
  methods: {
    handleShippingChange () {
      const baseInfo = this.$refs.baseInfo.form;

      const product = this.$refs.product;
      const productVOList = [];
      product.productList.forEach((item) => {
        productVOList.push({
          id: item.id,
          settlementAmount: item.settlementAmount,
          productCode: item.productCode,
          productPriceSigle: item.productPriceSigle,
          productNum: item.productNum,
          suggestedDate: item.suggestedDate
        });
      });
      const params = {
        contractId: baseInfo.id,
        modeOfShipping: baseInfo.modeOfShipping,
        isRebate: baseInfo.isRebate,
        rebateAmount: baseInfo.isRebate ? baseInfo.rebateAmount : 0,
        productVOList: productVOList,
        orderUnitName: baseInfo.orderUnit,
        salesType: baseInfo.salesType,
        supplyUnitId: baseInfo.supplyUnitId,
        communicationOrderDiscount: baseInfo.communicationOrderDiscount
      };
      this.getCalculateInterSettlementAmountV2(params);
    },
    getCalculateInterSettlementAmountV2 (params) {
      const product = this.$refs.product;
      getCalculateInterSettlementAmountV2(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          let _productList = product.productList;
          _productList.forEach((i) => {
            json.data.productVOList.forEach((j) => {
              // 产品单价、销售代码、数量一致
              if (i.productPriceSigle === j.productPriceSigle && i.productCode === j.productCode && i.productNum === j.productNum) {
                i.settlementAmount = j.settlementAmount;
              }
            });
          });

          // 运输方式是否有运费
          // if (json.data.freightFlag) {
          let freightInfo = _productList.find(item => item.productName === 'Freight');
          // 产品行中是否有运费，有则更新，没有则添加
          if (freightInfo !== undefined) {
            // freightInfo = { ...json.data.freightProduct };
            this.$set(freightInfo, 'productPriceSigle', json.data.freightProduct.productPriceSigle);
            this.$set(freightInfo, 'settlementAmount', json.data.freightProduct.settlementAmount);
            this.$set(freightInfo, 'orderAmount', json.data.freightProduct.orderAmount);
            this.$set(freightInfo, 'beforeSplitProductPriceSigle', json.data.freightProduct.beforeSplitProductPriceSigle);
          } else {
            _productList.push(json.data.freightProduct);
          }
          // } else {
          //   let freightInfoIndex = _productList.findIndex(item => item.productName === 'Freight');
          //   console.log(freightInfoIndex);
          //   // 删除已存在的运费
          //   if (freightInfoIndex !== -1) {
          //     delete _productList.splice(freightInfoIndex, 1);
          //   }
          // }
        }
      }).catch((res) => {

      });
    },
    async submit (val) {
      if (!this.$refs.baseInfo.form.regionCode) {
        this.$message.error('请填写区域');
        return;
      }
      let baseR = true;
      let Product = {};
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
      } else {
        baseR = this.$refs.baseInfo.validatedrafts();
      }
      if (val) {
        Product = await this.$refs.product.validatedrafts();
      } else {
        Product = await this.$refs.product.validate();
      }
      let overSeasSalesCountryCode = '';
      if (baseR && Product) {
        await getCountryOrSpecificationPowerCord('').then((res) => {
          let json = res.data;
          if (json.status === '200') {
            const country = this.$refs.baseInfo.form.soldCountry;
            overSeasSalesCountryCode = json.data.soldCountryList.filter(item => item.constantValue === country)[0].countryCode ?? '';
          }
        }).catch(() => {

        });
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;
        baseR.contractDetail.actualSettlementAmount = Product.actualSettlementAmount;
        baseR.contractDetail.orderSales = Product.orderSales;
        baseR.contractDetail.netSales = baseR.netSales;
        if (!val) {
          this.loading = true;
          const decision = await checkIntlExportCompliance(this,
            buildIntlOrderPublishComplianceRequest(this.form, Product.productList));
          if (!decision.allowBusiness) {
            this.loading = false;
            return;
          }
        }
        this.loading = true;
        saveOrderContractInfo({ ...baseR, contractProductInfos: Product.productList, overSeasSalesCountryCode: overSeasSalesCountryCode }).then((res) => {
          const json = res.data;
          this.loading = false;
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    createContractNumInitialize () {
      createContractNum('福州', '新建订单合同', '').then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.form.contractNum = json.data;
          this.form.customerContractNum = json.data;
          this.form.orderUnit = 'No first Channel';
          this.form.orderUnitCode = 'FX000000000001';
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.createContractNumInitialize();
  }
};
</script>
<style lang="scss" scoped></style>
